import "./HookFormField.scss";

import classNames from "classnames";
import { FormField } from "components/Forms/FormField";
import { LyneContextHelp } from "components/Lyne/LyneContextHelp";
import { LyneLabel } from "components/Lyne/LyneLabel";
import { getResource, useTranslations } from "providers";
import React, { PropsWithChildren } from "react";

export interface HookFormFieldProps extends FormField, PropsWithChildren {
  className?: string;
  hasFocus?: boolean;
}

export const HookFormField: React.FC<HookFormFieldProps> = ({
  name,
  label,
  children,
  className,
  required,
  hasFocus,
  contextHelp,
}) => {
  const i18n = useTranslations();
  className = classNames("hook-form-field", className, hasFocus ? "has-focus" : "");

  const titleToUse = label ? getResource(label) : i18n.Help;
  const contentToUse = contextHelp
    ? getResource(contextHelp)
    : i18n.ContextHelp_Fallback_Content.replace("{0}", `${label}`);

  return (
    <div className={className}>
      <div className="d-flex">
        {titleToUse && <LyneLabel name={name} label={titleToUse} required={required} />}
        {contentToUse && (
          <div className="ml-auto">
            <LyneContextHelp title={titleToUse} content={contentToUse} hideLabel />
          </div>
        )}
      </div>
      {children}
    </div>
  );
};
